<work-ui-modal #arbeitszeitCreateUpdateModal
               [showInlineBorders]="true"
               [titleText]="(timerecorddetailToUpdate() ? 'BEARBEITEN' : 'ARBEITSZEIT_ERFASSEN') | translate"
               modalId="arbeitszeitCreateUpdateModal">
  <ng-container modal-body>
    @if (arbeitszeitCreateUpdateModal.isOpen) {
      <!-- Template für das Formular -->
      <ng-template #formTemplate let-formgroup="formgroup">
        <form [formGroup]="formgroup" autocomplete="off">
          @if (timerecordtypeDropdownOptions() | async; as timerecordtypeDropdownOptions) {
            @if (timerecordtypeDropdownOptions && timerecordtypeDropdownOptions.length) {
              <work-ui-select [options]="timerecordtypeDropdownOptions"
                              formControlName="timerecordtypeId"
                              label="TYP" />
            }
          }

          <!-- TimeBlock Suggestions (Mehrfachauswahl im Create-Modus) -->
          @if (!timerecorddetailToUpdate() && timeBlockSuggestions().length > 0) {
            <div class="time-block-suggestions margin-bottom-16">
              <label class="work-label margin-bottom-8">{{ 'VORSCHLAEGE' | translate }}</label>
              <div class="flex wrap gap-8">
                @for (suggestion of timeBlockSuggestions(); track suggestion.id) {
                  <work-ui-button
                    (buttonClick)="toggleSuggestionSelection(suggestion)"
                    [text]="suggestion.timeStart.substring(0, 5) + ' - ' + suggestion.timeEnd.substring(0, 5)"
                    [disabled]="isSuggestionAlreadyUsed()(suggestion)"
                    [variant]="isSuggestionSelected(suggestion) ? 'primary' : 'secondary'"
                    size="small" />
                }
              </div>
            </div>
          }

          <!-- Von/Bis: immer anzeigen, ausser wenn 2+ Suggestions selektiert sind -->
          @if (timerecorddetailToUpdate() || timeBlockSuggestions().length === 0 || selectedSuggestions().size < 2) {
            <div class="flex gap-8">
              <work-ui-input-field formControlName="timeStart" label="VON" type="time" />
              <work-ui-input-field formControlName="timeEnd" label="BIS" type="time" />
            </div>
          }

          <!-- Project Suggestions from Montageplan -->
          @if (projectSuggestions().length > 0) {
            <div class="project-suggestions margin-bottom-16">
              <label class="work-label margin-bottom-8">{{ 'PROJEKTE_DIESE_WOCHE' | translate }}</label>
              <div class="flex wrap gap-8">
                @for (block of projectSuggestions(); track block.id) {
                  <work-ui-button
                    (buttonClick)="applyProjectSuggestion(block)"
                    [text]="block.projectStreet + ', ' + block.projectZipCode + ' ' + block.projectCity"
                    [variant]="projectsPlannedForToday().has(block.projectId) ? 'primary' : 'secondary'"
                    size="small" />
                }
              </div>
            </div>
          }

          <work-office-global-megasearch-input (projectSelected)="formgroup.patchValue({projectId: $event.selectedProject?.id})"
                                               (valueCleared)="formgroup.patchValue({projectId: null})"
                                               [disableResultContactLinks]="true"
                                               [searchCategories]="[WorkSearchCategoryEnum.ContactAndProjects]"
                                               [searchTerm]="projectSearchTerm()"
                                               label="PROJEKT"
                                               placeholder="SUCHEN"
          />
          <work-ui-input-field formControlName="notes" label="BEMERKUNGEN" [rows]="1" [setAutoHeight]="true" variant="textarea" />
          <div class="flex wrap gap-8">
            @for (suggestion of noteSuggestions; track suggestion) {
              <work-ui-button
                (buttonClick)="applyNoteSuggestion(formgroup, suggestion)"
                [text]="suggestion"
                size="small"
                variant="secondary" />
            }
          </div>
        </form>
      </ng-template>

      <!-- Bedingte Verwendung der Formgroups -->
      @if (timerecorddetailToUpdate()) {
        <ng-container *ngTemplateOutlet="formTemplate; context: {formgroup: formgroupUpdate}" />
      } @else {
        <ng-container *ngTemplateOutlet="formTemplate; context: {formgroup: formgroupCreate}" />
      }
    }
  </ng-container>
  <ng-container modal-footer>
    @if (timerecorddetailToUpdate()) {
      <work-ui-button (buttonClick)="save()" [disabled]="!formgroupUpdate.valid" text="SPEICHERN" />
    } @else {
      <work-ui-button (buttonClick)="save()" [disabled]="!formgroupCreate.valid || !canSaveCreate()" text="SPEICHERN" />
    }
  </ng-container>
</work-ui-modal>
